export default {
    job_name: '岗位名称',
    is_enable: '是否启用',
    add_user: '添加用户',
    query_user: '查询用户',
    search_tip: '请在添加新用户前，先通过搜索查询用户信息是否存在。',
    input_name: '请输入用户姓名',
    input_mobile: '请输入手机号',
    input_unit: '请输入工作单位',
    add_new_user: '添加新用户',
    edit_user: '编辑用户',
    staff_register_address: '工作人员注册地址',
    channel_open_status: '通道是否开放',
    reg_deadline: '注册截止日期',
    login_page_note: '通道注册登录页说明文字',
    index_page_note: '通道注册登录后首页说明文字',
    open_link: '打开链接',
    add_staff: '添加工作人员',
    onsite_job: '现场工作岗位',
    identity: '身份',
    sign_status: '签到状态',
    reg_time: '注册时间',
    volunteer: '大会志愿者',
    supplier_staff: '供应商工作人员',
    organizer_staff: '主办方工作人员',
    signed: '已签到',
    unsigned: '未签到',
    enabled: '启用',
    disabled: '未启用',
    select_staff_identity: '请选择工作人员身份'
};
